import CalendarEventKeyRange from '../store/schema/CalendarEventKeyRange';
import DateRange from '../store/schema/DateRange';
import { CalendarEventKey } from 'mini-calendar-event-types';

export type KeyRangeOrDateRange = CalendarEventKeyRange | DateRange;

export default function computeKeyRangeAndDateRange(
    range: KeyRangeOrDateRange
): { keyRange: CalendarEventKeyRange; dateRange: DateRange } {
    let keyRange: CalendarEventKeyRange = null;
    let dateRange: DateRange = null;
    if (isKeyRange(range)) {
        keyRange = <CalendarEventKeyRange>range;
        dateRange = {
            start: range.start.timestamp,
            end: range.end.timestamp,
        };
    } else {
        dateRange = <DateRange>range;
        keyRange = {
            start: {
                timestamp: range.start,
                itemId: '',
            },
            end: {
                timestamp: range.end,
                itemId: '',
            },
        };
    }
    return { keyRange, dateRange };
}

/**
 * Logic is based on 'User-Defined Type Guards' section mentioned in https://www.typescriptlang.org/docs/handbook/advanced-types.html.
 * @param toBeDetermined either a key range or date range.
 * @returns true if toBeDetermined is CalendarEventKeyRange.
 */
export function isKeyRange(
    toBeDetermined: KeyRangeOrDateRange
): toBeDetermined is CalendarEventKeyRange {
    return (toBeDetermined.start as CalendarEventKey).timestamp !== undefined;
}
